var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-view',[_c('van-overlay',{attrs:{"show":true,"custom-style":{backgroundColor: 'rgba(255,255,255, 1)'},"flex":"main:center cross:center"}},[_c('van-loading',{attrs:{"type":"spinner","color":"#000"}},[_vm._v(" 登录中... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }